import { render, staticRenderFns } from "./Extent.vue?vue&type=template&id=d88acc48&scoped=true&"
import script from "./Extent.vue?vue&type=script&lang=js&"
export * from "./Extent.vue?vue&type=script&lang=js&"
import style0 from "./Extent.vue?vue&type=style&index=0&id=d88acc48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88acc48",
  null
  
)

export default component.exports